export default {
  strict: true,
  namespaced: true,
  state: {
    promoCodes: {
      list: [],
      isMax: false,
      currentPage: 0,
      perPage: 20
    }
  },
  mutations: {
    resetPromoCodes (state) {
      state.promoCodes.list = []
    },
    addPromoCodes (state, value) {
      state.promoCodes.list.push(value)
    },
    setPromoCodesIsMax (state, value) {
      state.promoCodes.isMax = value
    },
    setPromoCodesCurrentPage (state, value) {
      state.promoCodes.currentPage = value
    }
  },
  sharedMutations: []
}



// WEBPACK FOOTER //
// ./src/store/consumer/promo-codes.js